import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {SettingComponent} from './setting/setting.component';
import {Authority} from '../shared/constants/authority.constants';
import {ResolvePagingParams} from '../core/services';

const routes: Routes = [
  {
    path: 'setting',
    component: SettingComponent,
    data: {
      title: 'Setting',
      authorities: [Authority.ADMIN]
    }
  },
  {
    path: 'currency',
    loadChildren: () => import('../pages/currency/currency.module').then(m => m.CurrencyModule),
  },
  {
    path: 'members',
    loadChildren: () => import('../pages/members/members.module').then(m => m.MembersModule)
  },
  {
    path: 'general-setting',
    loadChildren: () => import('../pages/general-setting/general-setting.module').then(m => m.GeneralSettingModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
